import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppPurchaseOrderPage.';
  public static readonly purchaseOrderEditorTitle = `${Id.prefix}purchaseOrderEditorTitle`;
  public static readonly purchaseOrderGlossary = `${Id.prefix}purchaseOrderGlossary`;
}

export class LangAppPurchaseOrderPage {
  private constructor() {}
  public static purchaseOrderEditorTitle(): string {
    return interpolate(Id.purchaseOrderEditorTitle);
  }
  public static purchaseOrderGlossary(): string {
    return interpolate(Id.purchaseOrderGlossary);
  }
}

export class AppPurchaseOrderPageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.purchaseOrderEditorTitle,
      "{{glossary 'purchase-order'}} Editor",
      'Title for the purchase order editor page'
    );
    register.add(
      Id.purchaseOrderGlossary,
      "{{glossary 'purchase-order'}}",
      'Glossary term for purchase order (singular)'
    );
  }
}
